var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "client"
  }, [(_vm.showlist == true) ? _c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter fa-xs",
    attrs: {
      "title": _vm.$t('inwardList.searchDRBtn'),
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions",
    staticStyle: {
      "margin-right": "35px",
      "margin-top": "10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-lg",
    attrs: {
      "title": _vm.$t('inwardList.addDRBtn')
    },
    on: {
      "click": function($event) {
        _vm.showAddForm(_vm.data)
      }
    }
  })])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "autocomplete": "off",
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getInwardMasterDataSearch($event)
      }
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.merchant')) + " ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "height": "32px",
      "padding": "8px",
      "padding-left": "13px",
      "border-radius": "0%"
    },
    attrs: {
      "options": _vm.listMerchantData1,
      "placeholder": _vm.$t('common.merchantPlaceholder'),
      "selected-option": _vm.item
    },
    on: {
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.merchant),
      callback: function($$v) {
        _vm.merchant = $$v
      },
      expression: "merchant"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block !important",
      "margin-top": "30px",
      "width": "16px"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    staticStyle: {
      "display": "inline-block",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "type": "checkbox",
      "id": "only_notinwarded1",
      "name": "only_notinwarded1"
    },
    on: {
      "change": function($event) {
        _vm.notinwarded($event)
      }
    },
    model: {
      value: (_vm.only_notinwarded),
      callback: function($$v) {
        _vm.only_notinwarded = $$v
      },
      expression: "only_notinwarded"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px",
      "color": "green !important"
    }
  }, [_c('label', {
    attrs: {
      "for": "only_notinwarded1"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.showGRN')))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.drno')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.drnoPlaceholder'),
      "id": "invreferenceid"
    },
    model: {
      value: (_vm.invreferenceid),
      callback: function($$v) {
        _vm.invreferenceid = $$v
      },
      expression: "invreferenceid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.po_asn')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-plus-o'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.po_asnPlaceholder'),
      "name": "po",
      "id": "po"
    },
    model: {
      value: (_vm.po),
      callback: function($$v) {
        _vm.po = $$v
      },
      expression: "po"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.invoiceId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.invoiceIdPlaceholder'),
      "id": "invoicevalue"
    },
    model: {
      value: (_vm.invoicevalue),
      callback: function($$v) {
        _vm.invoicevalue = $$v
      },
      expression: "invoicevalue"
    }
  })], 1)], 1), _vm._v(" "), (_vm.slaflag) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('sla.sla')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchSLA),
      expression: "searchSLA"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "searchSLA"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.searchSLA = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('sla.selectSLA')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Within SLA"
    }
  }, [_vm._v("Within SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Near SLA"
    }
  }, [_vm._v("Near SLA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SLA Breached"
    }
  }, [_vm._v("SLA Breached")])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.fromDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.toDate')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class=' fa fa-calendar'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "lang": "en",
      "type": "date",
      "placeholder": _vm.$t('common.datePlaceholder'),
      "format": "YYYY-MM-DD"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.drstatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.drstatus),
      expression: "drstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "drstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.drstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.drstatus')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "created"
    }
  }, [_vm._v("Created")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inprogress"
    }
  }, [_vm._v("In-progress")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "closed"
    }
  }, [_vm._v("Closed")])])])], 1), _vm._v(" "), (_vm.client == 1025) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.sapstatus')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sapstatus),
      expression: "sapstatus"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sapstatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sapstatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("ALL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("SAP Closed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("SAP OPEN")])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getInwardMasterSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" \n                      "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFlt
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                        " + _vm._s(_vm.$t('inwardList.reset')))])])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row expand"
  }, [_c('div', {
    staticClass: "col-md-4 s2 o1"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.table.title')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4  s2 o2"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 s1 o3"
  }, [(_vm.totalRows > 0) ? _c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('inwardList.table.count')) + " - \n                " + _vm._s(_vm.totalRows))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary cardtable cardreporttablerow",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "125px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.dr')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "125px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.po')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "125px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.drDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "125px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.invoice')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.merchant')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "80px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.totalBoxes')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "80px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.damagedBoxes')))])]), _vm._v(" "), (_vm.slaflag) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('sla.sla')))])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('inwardList.table.columns.action')))])])])]), _vm._v(" "), _c('tbody', [((_vm.listInwardMasterData.result && _vm.listInwardMasterData.result.length == 0) || _vm.listInwardMasterData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.table.listNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listInwardMasterData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [(data.status != 'closed') ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "title": "View Order Details"
      },
      on: {
        "click": function($event) {
          _vm.showgrcForm(data)
        }
      }
    }, [_vm._v(_vm._s(data.invreferenceid))]) : _vm._e(), _vm._v(" "), (data.status == 'closed') ? _c('a', {
      staticStyle: {
        "color": "green"
      },
      attrs: {
        "title": "View Order Details"
      }
    }, [_vm._v(_vm._s(data.invreferenceid))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pono))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.challanno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.merchantname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofboxes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.damagedboxes))]), _vm._v(" "), (_vm.slaflag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                        " + _vm._s(data.sladatetime)), _c('br'), _vm._v(" "), (data.slastatus == 'SLA Breached') ? _c('span', {
      staticClass: "badge badge-danger",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('sla.slabreached')))]) : (data.slastatus == 'Near SLA') ? _c('span', {
      staticClass: "badge badge-warning",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.breachdurationinmins / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.breachdurationinmins % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : (data.slastatus == 'Within SLA') ? _c('span', {
      staticClass: "badge badge-info",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(" " + _vm._s(Math.trunc(data.breachdurationinmins / 60)) + " " + _vm._s(_vm.$t('sla.hours')) + " " + _vm._s(Math.trunc(data.breachdurationinmins % 60)) + " " + _vm._s(_vm.$t('sla.minutes')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(data.issapclosed == '0' && _vm.client == 1025) ? _c('i', {
      staticClass: "fa fa-envelope-open-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "SAP Status"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.issapclosed == '1' && _vm.client == 1025) ? _c('i', {
      staticClass: "fa fa-envelope fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "SAP Status"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa fa-arrow-circle-down fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "GRC List"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getGRCListdetails(data)
        }
      }
    }), _vm._v(" "), (_vm.closedrFlag == true && data.status != 'closed' && _vm.clientview == 1) ? _c('i', {
      staticClass: " fa fa-times-rectangle-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "15px",
        "color": "red"
      },
      attrs: {
        "title": "Close DR"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showDRCloseConfirmation(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.closedrFlag == true && data.status == 'closed' && _vm.clientview == 1) ? _c('i', {
      staticClass: "fa fa-times-rectangle-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "15px"
      },
      attrs: {
        "title": "DR Closed"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fa fa-eye text-successeye fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View Dock Receipt Details"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getInwardetails(data)
        }
      }
    }), _vm._v(" "), (_vm.clientview == 1) ? _c('i', {
      staticClass: "fa fa-barcode text-successbarcode fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Print barcode"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openmodal(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.status != 'closed' && _vm.clientview == 1) ? _c('i', {
      staticClass: "fa fa-pencil fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      attrs: {
        "title": "Edit DR"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editDR(data)
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.status == 'closed' && _vm.clientview == 1) ? _c('i', {
      staticClass: "fa fa-pencil fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "Edit DR"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }) : _vm._e(), _vm._v(" "), (data.shorturl && _vm.clientviewInvoice == 1) ? _c('a', {
      attrs: {
        "href": _vm.baseUrl.concat(_vm.clientid, '/tiny/', data.shorturl),
        "target": "_blank",
        "rel": "noopener noreferrer"
      },
      on: {
        "click": function($event) {
          _vm.updateexpiredInvoice(data)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o fa-lg mt-2 ml-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": "View Invoice"
      }
    })]) : _vm._e()])])
  })], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.totalPage) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.inwarddetailmodal = false
      }
    },
    model: {
      value: (_vm.inwarddetailmodal),
      callback: function($$v) {
        _vm.inwarddetailmodal = $$v
      },
      expression: "inwarddetailmodal"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "printPoContent"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "hidden"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    slot: "header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeInwardDetailModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered ",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.heading')))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.client')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.listInwardDetailData1.clientname) + "\n                      ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px",
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.comments')))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.listInwardDetailData1.comments))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.merchant')) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.merchantname))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.dr')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.invreferenceid))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.transporter')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.transportername))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.po')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.pono))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('inwardList.printData.lr')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.lrnumber))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.invoice')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.challanno))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.vehicle')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.vehicleno))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.invoiceValue')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.invoicevalue))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.noOfBoxes')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.noofboxes))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.invoiceDate')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(_vm.listInwardDetailData1.invoicedate)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.damagedBoxes')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.damagedboxes))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.totalSKU')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.totalsku))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.materialDescription')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.listInwardDetailData1.materialdesc))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.totalInvoiceQuantity')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.totalinvoiceqty))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.createddate')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("date_time")(_vm.listInwardDetailData1.createddate)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.createdby')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.createdby))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.closeddate')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("date_time")(_vm.listInwardDetailData1.closeddate)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.closedby')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.listInwardDetailData1.closedby))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalpoqty')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.dataViewDRListing.totalpoqty))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalinvoiceqty')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataViewDRListing.totalinvoiceqty))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalgrnqty')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.dataViewDRListing.totalreceivedqty))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalputawayqty')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataViewDRListing.totalputawayqty))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalshortqty')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.dataViewDRListing.totalshortqty))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "font-weight": "bold",
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalexcessqty')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dataViewDRListing.totalexcessqty))])])])])])]), _vm._v(" "), (_vm.totalPageDetail > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageDetail,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage2
    },
    on: {
      "pagechanged": _vm.getPaginationDataDetail
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ConsigneeDetails",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.heading')))]), _vm._v(" "), (_vm.expanded == true) ? _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables"
  }, [_c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "colspan": "13",
      "id": "headerpd"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.heading')))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.lineNo')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.lineStatus')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.productID')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.productName')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.mrp')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.poLineQty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.invoiceLineQty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.grcReceivedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.grcAcceptedQty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('removeHold.acceptPutAwayQty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('removeHold.rejectPutAwayQty')))]), _vm._v(" "), _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.shortQty')))]), _vm._v(" "), (_vm.hideGRNExcessQtyFlag == true && _vm.hideGRNExcessQty == 0) ? _c('th', {
    staticClass: "tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.excessQty')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [((_vm.listGRCData && _vm.listGRCData.length == 0)) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "13",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.productDetails.dataNotFound')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.listGRCData), function(eachItem) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(eachItem.poitemid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.grnstatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.productname))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(eachItem.mrp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.orderedquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.totalreceivequantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.checkedquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.storeinquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.rejectedquantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eachItem.lessquantity))]), _vm._v(" "), (_vm.hideGRNExcessQtyFlag == true && _vm.hideGRNExcessQty == 0) ? _c('td', [_vm._v(_vm._s(eachItem.extraquantity))]) : _vm._e()])
  })], 2)])])]) : _vm._e()])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "10px",
      "margin-right": "20px",
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.loading ? _vm.loadingText : _vm.$t('inwardList.printData.print'))
    },
    on: {
      "click": function($event) {
        _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.printData.print')))])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "modal-lg"
    },
    on: {
      "ok": function($event) {
        _vm.showmodal = false
      }
    },
    model: {
      value: (_vm.showmodal),
      callback: function($$v) {
        _vm.showmodal = $$v
      },
      expression: "showmodal"
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.printBarcode.heading')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closemodal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('inwardList.printData.printBarcode.heading')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('quantity')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('inwardList.printData.printBarcode.placeholder'),
      "name": "quantity",
      "id": "quantity"
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('quantity')),
      expression: "errors.has('quantity')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.printData.printBarcode.errorMsg')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitprint
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('inwardList.printData.printBarcode.printBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closemodal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('inwardList.printData.printBarcode.cancelBtn')))])])])])])], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.closeDRModal = false
      }
    },
    model: {
      value: (_vm.closeDRModal),
      callback: function($$v) {
        _vm.closeDRModal = $$v
      },
      expression: "closeDRModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pincodemapping.confirmation')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusDRModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('common.closeDRConfirmation')) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.closeDRSave()
      }, function($event) {
        _vm.closeDRModal = false
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('pincodemapping.saveChanges')))]), _vm._v(" \n            "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusDRModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')))])])])])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.drListingModal = false
      }
    },
    model: {
      value: (_vm.drListingModal),
      callback: function($$v) {
        _vm.drListingModal = $$v
      },
      expression: "drListingModal"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(this.$t('inwardList.inward.drlisting')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeDRListingModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('inwardList.inward.ponumber')) + " :")]), _vm._v(" " + _vm._s(this.dataPONumber) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('inwardList.inward.drnumber')) + " :")]), _vm._v(" " + _vm._s(this.dataDRNumber) + "\n            ")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalpoqty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalinvoiceqty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalgrnqty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalputawayqty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalshortqty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v(_vm._s(_vm.$t('inwardList.inward.totalexcessqty')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataDRListing), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.totalpoqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.totalinvoiceqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalreceivedqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalputawayqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalshortqty))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.totalexcessqty))])])
  }))])])])])])])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.showlist == false) ? _c('div', [_c('div', [_c('inward', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow,
      "searchflag": _vm.searchflag
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showlist == 'EDIT') ? _c('div', [_c('div', [_c('inwardEdit', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showlist == 'GRC') ? _c('div', [_c('div', [_c('GRC', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow,
      "searchflag": _vm.searchflag
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showlist == 'GRCList') ? _c('div', [_c('div', [_c('GRClist', {
    attrs: {
      "filterData": _vm.filterData,
      "selectedRow": _vm.selectedRow,
      "searchflag": _vm.searchflag
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1)]) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7422b244", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7422b244","hasScoped":true}!./src/views/components/inwardlist/inwardlist.component.html
// module id = 825
// module chunks = 0